define([], function() {
    return {
        BREAKPOINT_MOBILE_SCREEN: 767, // in px
        BREAKPOINT_TABLET_SCREEN: 991
    };
});
